module.exports = __webpack_public_path__ + "static/media/settings.836a6124.svg";